export default __webpack_public_path__ + "d811f643c8e335dd1bc3029204b73ec0.png";